import script from "./MDataTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableRow.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableRow.vue?vue&type=style&index=0&id=7d70c75d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d70c75d"]])

export default __exports__